import { Typography } from '@material-ui/core'
import * as React from 'react'

import { containerStyles } from '../../styles/ContainerStyles'
import { textStyles } from '../../styles/TextStyles'
import { formatSeconds } from '../../utils/helper'
import { StartedGameDto } from '../../utils/types'
import { ContinueButton } from '../atoms/ContinueButton'
import { VideoPlayer } from './VideoPlayer'

interface Props {
    game: StartedGameDto
    secondsLeft: number
    onComplete(): void
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const GameLoserView: React.FC<Props> = ({ game, onComplete, secondsLeft }) => {

    const styles = containerStyles()
    const styles1 = textStyles()

    return (

        <div className={styles.outerLostDiv}>
            <Typography className={styles1.lostText} variant="h5">
                Desværre klarede i ikke tidsrejsen <br/> Bedre held næste gang!
            </Typography>
            <div style={{ width: '100%', alignSelf: 'center' }}>
                <VideoPlayer videoUri="https://vimeo.com/531459537/e6542f469b" autoplay/>
            </div>
            <div className={styles.lostTimerDiv}>
                <span className={styles.timerContainerLost}>
                    {formatSeconds(secondsLeft)}
                </span>
            </div>
            <div className={styles.lostBtnDiv}>
                <ContinueButton title="Start tidsrejsen!" onClick={onComplete}/>
            </div>
        </div>
    )
}
